import { useQuestionnaireNavigation } from '@/context/NavigationProvider';
import { Button } from '@/components/ui/button';
import Info2Pic from '@/assets/Onboarding/BlignyInfo2Pic.png';
import { PatientPageLayout } from '@/components/PatientPageLayout';

export const BlignyIntro2Page = () => {
  const { navigateNext } = useQuestionnaireNavigation();

  return (
    <PatientPageLayout
      title={
        <h1 className="text-2xl min-[23rem]:text-3.5xl font-semibold leading-tight nxs:text-center nsm:mt-4">
          À deux, c&apos;est encore mieux !
        </h1>
      }
      contentClassName="flex flex-col items-center justify-center nxs:text-center"
      footer={
        <div className="flex w-full flex-col items-center mx-auto">
          <Button variant="ctaPrimary" size="lg" onClick={navigateNext}>
            Continuer
          </Button>
        </div>
      }
    >
      <div className="flex flex-col items-center gap-5 text-center max-w-86">
        <img src={Info2Pic} alt="Couple coopérant" />
        <p className="leading-5 font-light w-full">
          Un proche peut vous aider à remarquer <br /> ce qui se passe pendant
          votre sommeil.
        </p>
        <p className="font-medium leading-5 w-full">
          Si possible, complétez ce questionnaire <br /> avec la personne qui
          partage vos nuits.
        </p>
      </div>
    </PatientPageLayout>
  );
};
